import { Component } from '@angular/core'
import {
	NavController,
	LoadingController,
	IonicPage,
	NavParams,
	ToastController
} from 'ionic-angular'

import { DeviceProvider } from '../../providers/device/device'

import { Device } from '../../models/models'

import { DeviceEditPage } from '../../pages/device-edit/device-edit'
import { AuthProvider } from '../../providers/auth/auth'
//import { CondominiumShowPage } from '../condominium-show/condominium-show';
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-device-show',
	templateUrl: 'device-show.html',
})
export class DeviceShowPage {
	device: Device = null;
	isDeviceLoading: boolean = true;

	constructor(
		public auth: AuthProvider,
		public devices: DeviceProvider,
		public loadingCtrl: LoadingController,
		public navCtrl: NavController,
		public navParams: NavParams,
		public toastCtrl: ToastController
	) {
		this.device = navParams.get('device')
	}

	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	ionViewWillEnter() {
		this.reload()
	}
	/*
	goToCondominiumShow(){
	this.navCtrl.push(CondominiumShowPage,{condominium:this.device.condominium});
	*/
	goToDeviceEdit() {
		this.navCtrl.push(DeviceEditPage, { device: this.device })
	}

	reload() {
		let self = this
		this.isDeviceLoading = true
		this.devices.getById(this.device.id, ['condominium', 'condominium.housingUnits']).then((device: Device) => {
			self.device = device
			self.isDeviceLoading = false
			console.log('Dispositivo aggiornato: ', self.device)
		}).catch(error => {
			self.isDeviceLoading = false
			console.error("Errore recuperando i dati del dispositivo:", error)
			let toast = self.toastCtrl.create({
				message: 'Errore recuperando i dati del dispositivo',
				position: 'middle',
				duration: 3000,
				cssClass: "danger"
			})
			toast.present()
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/device-show/device-show.ts